<script>
export default {
  onLaunch: function () {
    console.log('App Launch')
  },
  onShow: function () {
    console.log('App Show')
  },
  onHide: function () {
    console.log('App Hide')
  },
}
</script>

<style>
:root {
	--h5-safe-area-inset-top: env(safe-area-inset-top);
}

@supports (padding-top: constant(safe-area-inset-top)) {
	:root {
		--h5-safe-area-inset-top: constant(safe-area-inset-top);
	}
}

.uni-page-head {
	padding-top: calc(7px + var(--h5-safe-area-inset-top, 0px));
	height: calc(44px + var(--h5-safe-area-inset-top, 0px));
}

.uni-page-head ~ .uni-placeholder {
	height: calc(44px + var(--h5-safe-area-inset-top, 0px));
}
</style>
